export const AuthRedirectPage: React.FC<{ text: string; }> = ({ text }) => {
  return <p>{text}</p>;
};
